import {useState} from 'react'

import styles from './ProjectItemSection.module.css'
import {ProjectItemSectionFieldList} from './ProjectItemSectionFieldList'
import type {ProjectItemSectionViewFragment} from './ProjectItemSectionView'
import {ProjectItemSectionView} from './ProjectItemSectionView'

export type ProjectItemSectionProps = {
  projectItem: ProjectItemSectionViewFragment
  isOpen: boolean
  onIssueUpdate: () => void
  isProjectClosed: boolean
  owner: string
  repo: string
  issueNumber: number
}

export function ProjectItemSection({
  projectItem: data,
  onIssueUpdate,
  isOpen = false,
  isProjectClosed,
  owner,
  repo,
  issueNumber,
}: ProjectItemSectionProps) {
  const [open, setOpen] = useState(isOpen)

  return (
    <div className={styles.ProjectItemSectionContainer}>
      <ProjectItemSectionView
        projectItem={data}
        open={open}
        setOpen={setOpen}
        onIssueUpdate={onIssueUpdate}
        isSelectedProject={isOpen}
        isProjectClosed={isProjectClosed}
        owner={owner}
        repo={repo}
        issueNumber={issueNumber}
      />
      {open && (
        <ProjectItemSectionFieldList
          projectItemId={data.id}
          projectId={data.project.id}
          owner={owner}
          repo={repo}
          issueNumber={issueNumber}
          onIssueUpdate={onIssueUpdate}
        />
      )}
    </div>
  )
}
